import { useEffect } from "react";

import { getCampaign } from "generated/api/campaign";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";

import { useAddTouchpointsFromMondayTemplateContext } from "components/modals/add-touchpoints-from-template-modal/context/add-touchpoints-from-monday-template-context";

export const useUsedCampaignTemplateIds = () => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const { setUsedCampaignTemplateIds } = useAddTouchpointsFromMondayTemplateContext();

  useEffect(() => {
    const fetchUsedCampaignTemplateIds = async () => {
      try {
        const campaign = getCampaign();
        const results = await campaign.getUsedCampaignTemplateIds({
          clientId: currentClient.id,
          id: currentCampaign.id,
        });

        setUsedCampaignTemplateIds(new Set(results));
      } catch (err) {
        console.error("Failed to fetch used campaign template IDs", err);
        setUsedCampaignTemplateIds(new Set());
      }
    };

    fetchUsedCampaignTemplateIds();
  }, [currentCampaign.id, currentClient.id, setUsedCampaignTemplateIds]);
};
